import React from 'react';
import { Leaf, Users, TrendingUp, IndianRupee } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Leaf,
      title: 'Premium Biochar Solutions',
      description: 'Transform agricultural waste into soil-enhancing biochar for sustainable farming and carbon sequestration.',
      stat: '40% soil improvement',
      image: 'https://customer-assets.emergentagent.com/job_bloom-cycles-copy/artifacts/9omoq8at_What-Is-Biochar.webp'
    },
    {
      icon: TrendingUp,
      title: 'Climate Smart Agriculture',
      description: 'Data-driven insights and tools to implement climate-resilient farming practices.',
      stat: '2.5T CO₂ sequestered',
      image: 'https://images.pexels.com/photos/18466769/pexels-photo-18466769.jpeg'
    },
    {
      icon: Users,
      title: 'Farmer Community Network',
      description: 'Connect with progressive farmers and share knowledge in our thriving sustainability community.',
      stat: '10K+ farmers',
      image: 'https://images.unsplash.com/photo-1728017942667-9509fe2b603b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxydXJhbCUyMGZhcm1pbmd8ZW58MHx8fHwxNzYyMzM3NzgyfDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: IndianRupee,
      title: 'Soil Health Enhancement',
      description: 'Proven biochar applications that improve soil fertility and water retention capacity.',
      stat: '₹15K+ earnings',
      image: 'https://images.pexels.com/photos/12314915/pexels-photo-12314915.jpeg'
    }
  ];

  return (
    <section id="features" className="pt-0 pb-0 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16 pt-20">
          <h2 className="text-4xl font-heading font-bold text-neo-black mb-4">
            Complete Climate Solutions for Agriculture
          </h2>
          <p className="text-xl text-neo-gray font-body mb-8">
            Everything you need to transform your farm into a climate-positive operation
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="group bg-gray-50 border-2 border-neo-emerald/20 rounded-2xl overflow-hidden hover:border-neo-emerald/40 hover:shadow-xl hover:shadow-neo-emerald/20 transition-all duration-300"
              >
                <div className="relative h-56 overflow-hidden">
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-neo-black/90 via-neo-black/40 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                    <div className="w-14 h-14 bg-neo-emerald/20 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg border border-neo-emerald/30">
                      <Icon className="w-7 h-7 text-neo-emerald" />
                    </div>
                    <div className="text-neo-white font-heading font-bold text-lg bg-neo-emerald px-4 py-2 rounded-lg glow-emerald">
                      {feature.stat}
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-heading font-bold text-neo-black mb-2">{feature.title}</h3>
                  <p className="text-neo-gray font-body">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
